import React from 'react';

const Footer = () => {
	return (
		<footer className='footer'>
			<span>YUNA Solution, TOO Kazakhstan</span>

			<span>
				Email{' '}
				<a
					href='mailto:develop@petgeo.org'
					target='_blank'
					rel='noopener noreferrer'
					className='privacy__email'
				>
					develop@petgeo.org
				</a>
			</span>
		</footer>
	);
};

export default Footer;
